import type { Table2DComponentSpec } from "../Processing/types";
import type { DuplicationHandler } from "../widgetContract";

export const table2dDuplicate: DuplicationHandler<Table2DComponentSpec> = (spec) => {
  const qidMap = new Map<string, string>();
  spec.queryIds = spec.queryIds.map((old) => {
    const q = crypto.randomUUID();
    qidMap.set(old, q);
    return q;
  });
  const misc = spec.table_2d_builder_misc as any;
  if (misc?.metrics) {
    misc.metrics = misc.metrics.map((m: any) => ({ ...m, queryId: qidMap.get(m.queryId) ?? m.queryId }));
  }
};
